import { ResponseDataGet } from "../../../../models/responseDataGet";
import { agroApi } from "../../api";
import { Paths } from "../../../../paths";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";

export const registerStatusApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getRegisterStatusList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.registerStatus }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getRegisterStatusById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.registerStatus }/${ id }`,
		method: 'GET',
	  }),
	}),

	addRegisterStatus: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.registerStatus }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editRegisterStatus: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.registerStatus }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteRegisterStatus: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.registerStatus }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddRegisterStatusMutation,
  useDeleteRegisterStatusMutation,
  useEditRegisterStatusMutation,
  useGetRegisterStatusByIdQuery,
  useGetRegisterStatusListQuery,
  useLazyGetRegisterStatusListQuery
} = registerStatusApi;
